/**
 * Country options for the supplier sign-up form. Values are ISO 3166-1 alpha-2
 * codes (stored on the account); labels are the display names. Kept as a small
 * curated list of the markets suppliers register from; extend as needed.
 */
export interface CountryOption {
    code: string;
    name: string;
}

export const COUNTRIES: CountryOption[] = [
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' },
    { code: 'MX', name: 'Mexico' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'IE', name: 'Ireland' },
    { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' },
    { code: 'ES', name: 'Spain' },
    { code: 'IT', name: 'Italy' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'SE', name: 'Sweden' },
    { code: 'PL', name: 'Poland' },
    { code: 'IN', name: 'India' },
    { code: 'CN', name: 'China' },
    { code: 'JP', name: 'Japan' },
    { code: 'KR', name: 'South Korea' },
    { code: 'SG', name: 'Singapore' },
    { code: 'AU', name: 'Australia' },
    { code: 'BR', name: 'Brazil' },
    { code: 'AE', name: 'United Arab Emirates' },
];

const VALID_CODES = new Set(COUNTRIES.map((c) => c.code));

export function isValidCountryCode(code: string): boolean {
    return VALID_CODES.has(code);
}
